import { formatNumbers } from "../../../utils/NumberFormat";
import styles from "./RevenueOverview.module.css";
import { Row, Col, Card } from "antd";

const RevenueOverview = ({ data }) => {
  console.log("data?.pendingInvoicesTotal", data?.pendingInvoicesTotal)
  const overviewData = [
    {
      label: "Revenue",
      count: "$" + data?.revenueCountData?.yearlyTotal || 0,
      percent: data?.revenueCountData?.percentageIncrease + "%" || "0%",
      duration: "last month",
      up: data?.revenueCountData?.currentMonthTotal || 0,
      positive: !data?.revenueCountData?.percentageIncrease?.includes("-"),
    },
    {
      label: "Pending Invoices",
      count: data?.pendingInvoicesTotal || 0,
    },
    {
      label: "Most Subscribed Plan",
      count: data?.subscriptionData?.mostSubscribed?.count || 0,
      description: data?.subscriptionData?.mostSubscribed?.subscriptionName || 0,
    },
  ];

  return (
    <Row gutter={[8, 8]} className={styles.column_wrap}>
      {overviewData.map((item) => {
        return (
          <Col xs={24} lg={6} md={12} sm={12} xl={6} key={item.label}>
            <Card className={styles.content_wrap}>
              <div className={styles.label}>{item.label}</div>
              <div className={styles.count}>{item.description ? `${item.description} (${formatNumbers(item.count)})` : formatNumbers(item.count)}</div>
              {item.percent && (
                <div className={styles.details}>
                  <span
                    className={
                      item.positive
                        ? styles.positive_percent
                        : styles.negative_percent
                    }
                  >
                    {item.percent}
                  </span>{" "}
                  from {item.duration} (up ${formatNumbers(item.up)} )
                </div>
              )}
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default RevenueOverview;
